import * as echarts from 'echarts';
import { useEffect, useRef, useState } from 'react';

type EChartsInstance = echarts.ECharts | null;
export type MyChartOptions = echarts.EChartsOption;

type Props = {
  chartsOption: MyChartOptions;
};

const EchartsComponent = (props: Props) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<EChartsInstance>(null);

  const initChart = () => {
    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }
    chartInstance.current.setOption(props.chartsOption);
  };

  const handleResize = () => {
    if (chartInstance.current) {
      chartInstance.current.resize();
    }
  };
  
  useEffect(() => {
    initChart();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [props.chartsOption]);

  return (
    <div ref={chartRef} style={{ width: '100%', height: '100%' }}></div>
  );
};

export default EchartsComponent;